import { render, staticRenderFns } from "./jcrecord.vue?vue&type=template&id=cc0b89f4&"
import script from "./jcrecord.vue?vue&type=script&lang=js&"
export * from "./jcrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports